<template>

	<div :class="['tw-form-group', {'lg:grid grid-cols-12 gap-4': fullWidth}]">
		<label :class="['tw-form-group-label', {'col-span-5': fullWidth}]">
			{{label}}
		</label>
		<div :class="{'col-span-7': fullWidth}">
			<div class="mt-1 relative rounded-md">
				<slot></slot>
			</div>
			<p class="mt-1 text-sm text-gray-500" id="description">
				{{description}}
			</p>
			<div class="tw-form-error" v-if='errors && errors.hasOwnProperty(field)'>
				{{Array.isArray(errors[field]) ? errors[field][0] : errors[field]}}
			</div>
		</div>
	</div>

</template>

<script>
	
	export default{
		name:'tw-form-group',
		props:{
			label:{
				type:String,
				default:'',
			},
			description:{
				type:String,
				default:'',
			},
			errors:{
				type:Object,
				default:null,
			},
			field:{
				type:String,
				default:'',
			},
			fullWidth:{
				type:Boolean,
				default:false,
			},
		},
		data:() => ({

		}),
		methods:{

		}
	}
</script>
